import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { Bell } from 'lucide-react';
import React from 'react';

import { useNotifications } from '../../hooks/useNotifications';
import {
  Sheet,
  SheetContent,
  SheetTrigger,
  SheetTitle,
  SheetDescription,
} from '../ui/sheet';

import { NotificationCenter } from './NotificationCenter';

export const NotificationBell: React.FC = React.memo(() => {
  const { notifications, unreadCount, markAllAsRead, handleAction } =
    useNotifications();

  return (
    <Sheet>
      <SheetTrigger asChild>
        <button className='relative p-2 rounded-full text-gray-400 hover:text-gray-500 hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500'>
          <Bell className='h-6 w-6' />
          {unreadCount > 0 && (
            <span className='absolute top-1 right-1 flex h-4 w-4 shrink-0 translate-x-0 translate-y-0 items-center justify-center rounded-full bg-red-500 text-[10px] font-medium text-white ring-2 ring-white animate-in zoom-in-50 duration-300'>
              {unreadCount > 9 ? '9+' : unreadCount}
            </span>
          )}
        </button>
      </SheetTrigger>
      <SheetContent className='w-[400px] sm:w-[540px] flex flex-col'>
        <VisuallyHidden>
          <SheetTitle>Notifications</SheetTitle>
          <SheetDescription>
            View and manage your system notifications and alerts.
          </SheetDescription>
        </VisuallyHidden>
        <NotificationCenter
          notifications={notifications}
          onMarkAllRead={markAllAsRead}
          onAction={handleAction}
        />
      </SheetContent>
    </Sheet>
  );
});
NotificationBell.displayName = 'NotificationBell';
